<template>
  <div>

    <admin-filter
      :items="filterData"
      :itemFiltered.sync="filtered"
      @getData="getDataFromServer"
      title="슈퍼파트너 조회"
      desc="슈퍼파트너들의 현황을 조회할 수 있습니다."
    ></admin-filter>

    <div class="btn-group-justify-end" v-if="page!=='purchase'">
      <button @click="$router.push('superpartner/create')"
              class="button is-primary">슈퍼파트너 등록</button>
    </div>

    <admin-table :field_list="tableData"
                 :items="tableItems"
                 :filtered="filtered"
                 :allCount="allCount"
                 :filteredCount="filteredCount"
                 :table_width="700"
                 @getData="getDataFromServer"
                 @ordering="ordering"
                 @selPageLength="selPageLength">

      <div slot="purchase" slot-scope="props" v-if="page==='purchase'" style="width: 80px">
        <button class="button half" @click="selectUser(props.item)">선택</button>
      </div>

      <div slot="name" slot-scope="props" style="cursor:pointer;text-decoration:underline">
        <span @click="detailLink(props.item.id)">{{ props.item.name }}</span>
      </div>

      <div slot="partner" slot-scope="props">
        {{ isPartnerUser(props.item) }}
      </div>

      <div slot="login_type" slot-scope="props">
        {{ convertLoginType(props.item.login_type) }}
      </div>



      <div slot="modify_delete" slot-scope="props">
        <button class="button half"
                @click.stop.prevent="clickItem(props.item,'update')" style="margin-right:4px">수정</button>
        <button class="button half is-danger"
                @click.stop.prevent="clickItem(props.item,'delete')">삭제</button>
      </div>
    </admin-table>

  </div>
</template>

<script>
  import ListMixin from '@/mixins/ListMixin'

  export default {
    name: 'SuperPartnerList',
    mixins: [
      ListMixin  // 목록페이지의 공통적인 데이터 및 함수는 List.js에 다 구성되어 있다.
    ],
    props: ['page'],
    data() {
      return {
        user_id: 0
      }
    },
    created(){
      this.init();
    },
    methods: {
      init() {
        /* 테이블, 필터를 구성할 structure_path, url을 파라미터로 넘겨준다.
     *  structure.js에 structure_path에 맞게 데이터를 생성한다.
     *  해당 url에 맞게 axios 호출이 잘되는지 확인한다.
     * */
        this.initializing('super_partner', 'super-partner');

        this.getPackages();

        // 수기 주문 페이지에서 슈퍼파트너 페이지를 모달로 띄울 경우
        if(this.page === 'purchase') {
          if(this.tableData[0].eng_name !== 'purchase') {
            this.tableData.splice(0, 0, {
              eng_name: 'purchase',
              ko_name: '',
              width: '70px'
            });
          }

          for(let i=0; i<this.tableData.length; i++){
            if(this.tableData[i].eng_name==='modify_delete') {
              this.tableData.splice(i, 1);
            }
          }
        }
        else {
          // modify_delete 키 유무에 따른 처리
          let is_key = false;
          for(let x=0; x<this.tableData.length; x++){
            if(this.tableData[x].eng_name === 'exhibition') {
              this.tableData.splice(x, 1);
            }
            else if(this.tableData[x].eng_name === 'modify_delete'){
              is_key = true;
              break;
            }
          }
          if (!is_key) {
            this.tableData.push({eng_name: 'modify_delete', ko_name:'수정/삭제', width: '120px'});
          }
        }
      },
      getDataFromServer() {
        this.getData();
      },
      convertLoginType(name) {
        switch(name) {
          case 'email': return '이메일';
          case 'kakao': return '카카오';
          case 'naver': return '네이버';
          case 'facebook': return '페이스북';
          case 'google': return '구글';
        }
      },
      isPartnerUser(item) {
        if(item.partner) return '파트너 담당자';
        else return item.grade_name;
      },
      // 이메일 모달 오픈
      openMailModal(id) {
        this.$modal.show('mailModal');
        this.user_id = id;
      },
      detailLink(id) {
        this.$router.push(this.getPath(`superpartner/create?id=${id}`))
      },
      getPackages(){
        let packages = this.$store.getters.getPackages;
        // 마스터 백오피스 경우 이메일 인증 / 강제인증 / 인증안됨 값 구분이 필요해서 인증 구분 컬럼을 추가해야함.
        if(packages[0].name==='launchpack') {
          let isType = false;
          this.tableData.forEach(item=>{
            if(item.eng_name==='auth_type') isType = true;
          })
          if(!isType) {
            this.tableData.splice(this.tableData.length-1, 0, {
              eng_name: 'auth_type',
              ko_name: '인증구분',
              width: '100px'
            })
            this.tableData.splice(this.tableData.length-1, 0, {
              eng_name: 'is_mail',
              ko_name: '발송 여부',
              width: '100px'
            })
            this.tableData.splice(this.tableData.length-1, 0, {
              eng_name: 'send_mail',
              ko_name: '이메일 발송',
              width: '100px'
            })
          }
        }
      },
      clickItem(item, types) {
        // 수정
        if (types === 'update') {
          this.$router.push(this.getPath('superpartner/create?id=' + item.id));
        }
        // 삭제
        else if (types === 'delete') {

          let value = {
            id: item.id,
            url: 'member/user/',
            title: '슈퍼파트너을 탈퇴시키겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      selectUser(user){
        this.$emit('selectUser', user);
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
